import type { FieldErrors, FieldValues, UseFormHandleSubmit } from "react-hook-form";

type FormValidationResponse<T extends FieldValues> =
  | {
      isValid: true;
      errors?: never;
    }
  | {
      isValid: false;
      errors?: FieldErrors<T>;
    };

/**
 * Validate react-hook-form and extract any errors
 */
export const validateForm = <T extends FieldValues>(
  handleSubmit: UseFormHandleSubmit<T>
): Promise<FormValidationResponse<T>> =>
  new Promise((resolve) => {
    handleSubmit(
      () => resolve({ isValid: true }),
      (errors) => resolve({ isValid: false, errors })
    )();
  });
